export default [
    {
      path: '/dash',
      name: 'dash',
      component: () => import('@/views/dash/dash.vue'),
    },
]